<template>
  <v-dialog v-model="show" max-width="720">
      <v-card>
        <v-card-title>
          {{ title}}
        </v-card-title>
        <v-container class="px-6">
          <v-text-field
            outlined
            label="Question"
            v-model="form.question"
            :error-messages="form.$getError('question')"/>

          <content-editor
            label="Answer"
            v-if="show"
            v-model="form.answer"
            :error-messages="form.$getError('answer')"/>

          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn text class="text-capitalize" @click="show = false">Cancel</v-btn>
            <v-btn color="primary" class="text-capitalize" @click="success">Add</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
  </v-dialog>
</template>
<script>
import Form from '@/utils/form'
import ContentEditor from '@/components/ContentEditor'

export default {
  props: {
    title: {
      type: String,
      default: 'FAQ'
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ContentEditor
  },
  data () {
    return {
      show: this.value,
      form: new Form({
        question: null,
        answer: null
      })
    }
  },
  watch: {
    value (val) {
      this.form.$reset()
      this.show = val
    },

    show (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    success () {
      this.form.$clearErrors()
      this.validate()
      if (!this.form.$hasErrors()) {
        this.show = false
        this.$emit('success', this.form.$data())
      }
    },
    validate () {
      if (this.form.question === null || this.form.question.trim() === '') {
        this.form.$setError('question', 'The title is required')
      }

      if (this.form.answer === null || this.form.answer.trim() === '') {
        this.form.$setError('answer', 'The sub title is required')
      }
    }
  }
}
</script>
